import React, { useEffect, useState } from "react";
import { Form, Container, Row, Col, Card } from "react-bootstrap";
import { useDispatch } from "react-redux";

import { getActivity } from "../../store/slices/activity";
import { toast } from "react-toastify";
import Select from "react-select";

export default function EditQuotationActivityStep({
  packageId,
  activities,
  setActivities,
  nextStep,
  prevStep,
}) {
  const dispatch = useDispatch();
  const [masterActivities, setMasterActivities] = useState([]);
  const [vendorsMap, setVendorsMap] = useState({});
  const [timingsMap, setTimingsMap] = useState({});
  const [errors, setErrors] = useState([]);


useEffect(() => {

  const fetchActivities =
    async () => {

      try {

        const actRes =
          await dispatch(
            getActivity()
          ).unwrap();

        setMasterActivities(
          actRes?.activity || []
        );

      } catch (err) {

        toast.error(
          "Failed to load activities"
        );

      }
    };

  fetchActivities();

}, [dispatch]);

  useEffect(() => {
    const preloadVendorsAndTimings = () => {
      activities.forEach((config, configIndex) => {
        config.activities?.forEach((row, actIndex) => {
          if (!row.activity) return;

          const key = `${configIndex}_${actIndex}`;

          const selectedActivity = masterActivities.find(
            (act) => act._id === row.activity,
          );

          if (!selectedActivity?.locations) return;

          const activeLocations = selectedActivity.locations.filter(
            (loc) => loc.vendor && loc.isActive,
          );

          const vendorList = activeLocations.map((loc) => loc.vendor);

          setVendorsMap((prev) => ({
            ...prev,
            [key]: vendorList,
          }));

          if (row.vendor) {
            const location = activeLocations.find(
              (loc) => loc.vendor?._id === row.vendor,
            );

            if (location?.timings) {
              setTimingsMap((prev) => ({
                ...prev,
                [key]: location.timings,
              }));
            }
          }
        });
      });
    };

    if (activities.length && masterActivities.length) {
      preloadVendorsAndTimings();
    }
  }, [activities, masterActivities]);


  const addActivityRow = (configIndex) => {
    const updated = [...activities];

    updated[configIndex].activities.push({
      activity: "",
      vendor: "",
      timing: "",
    });

    setActivities(updated);
  };

  const removeActivityRow = (configIndex, actIndex) => {
    const updated = [...activities];

    updated[configIndex].activities = updated[configIndex].activities.filter(
      (_, i) => i !== actIndex,
    );

    setActivities(updated);
  };


const handleChange = (
  configIndex,
  actIndex,
  field,
  value
) => {

  const updated = [...activities];

  updated[configIndex]
    .activities[actIndex][field] =
    value;

  const key =
    `${configIndex}_${actIndex}`;

  /* =====================================
     ACTIVITY CHANGE
  ===================================== */

  if (field === "activity") {

    const selectedActivity =
      masterActivities.find(
        (a) => a._id === value
      );

    if (
      !selectedActivity?.locations
    ) {

      setVendorsMap((prev) => ({
        ...prev,
        [key]: [],
      }));

      return;
    }

    const vendorList =
      selectedActivity.locations
        .filter(
          (loc) =>
            loc.vendor &&
            loc.isActive
        )
        .map((loc) => loc.vendor);

    setVendorsMap((prev) => ({
      ...prev,
      [key]: vendorList,
    }));

    updated[configIndex]
      .activities[actIndex]
      .vendor = "";

    updated[configIndex]
      .activities[actIndex]
      .timing = "";

    /* RESET PRICE DATA */

    updated[configIndex]
      .activities[actIndex]
      .price = 0;

    updated[configIndex]
      .activities[actIndex]
      .costType = "perPerson";

    updated[configIndex]
      .activities[actIndex]
      .quantity = 1;

    updated[configIndex]
      .activities[actIndex]
      .isIncluded = true;
  }

  /* =====================================
     VENDOR CHANGE
  ===================================== */

  if (field === "vendor") {

    const selectedActivity =
      masterActivities.find(
        (a) =>
          a._id ===
          updated[configIndex]
            .activities[actIndex]
            .activity
      );

    const location =
      selectedActivity?.locations?.find(
        (loc) =>
          loc.vendor?._id === value &&
          loc.isActive
      );

    const timingList =
      location?.timings || [];

    setTimingsMap((prev) => ({
      ...prev,
      [key]: timingList,
    }));

    updated[configIndex]
      .activities[actIndex]
      .timing = "";

    /* IMPORTANT */

    updated[configIndex]
      .activities[actIndex]
      .price =
      Number(location?.price || 0);

    updated[configIndex]
      .activities[actIndex]
      .costType =
      location?.costType ||
      "perPerson";

    updated[configIndex]
      .activities[actIndex]
      .quantity = 1;

    updated[configIndex]
      .activities[actIndex]
      .isIncluded = true;

    console.log(
      "ACTIVITY PRICE SET",
      updated[configIndex]
        .activities[actIndex]
    );
  }

  setActivities(updated);
};


  const validateActivityForm = () => {
    let isValid = true;
    const newErrors = [];

    activities.forEach((config, configIndex) => {
      newErrors[configIndex] = [];

      config.activities.forEach((row, actIndex) => {
        newErrors[configIndex][actIndex] = {};

        if (row.activity && !row.vendor) {
          newErrors[configIndex][actIndex].vendor = "Please select vendor";
          isValid = false;
        }
      });
    });

    setErrors(newErrors);
    return isValid;
  };
  const copyToAllOptions = (sourceConfig) => {
  setActivities((prev) => {
    return prev.map((config) => {

      // same day, different option
      if (
        String(config.dayPlan) ===
          String(sourceConfig.dayPlan) &&
        String(config.packageOption) !==
          String(sourceConfig.packageOption)
      ) {
        return {
          ...config,
          activities: sourceConfig.activities.map((act) => ({
            ...act,
          })),
        };
      }

      return config;
    });
  });

  toast.success("Copied to all options");
};

  const handleSubmit = async () => {
    try {
      
      nextStep();
    } catch (err) {
      toast.error("Failed to save activities");
    }
  };


const activitiesByOption =
  Object.values(
    activities.reduce(
      (acc, activity) => {

        const optionId =
          activity.packageOption;

        if (!acc[optionId]) {

          acc[optionId] = {
            option: {
              _id: optionId,

              name:
                activity
                  ?.packageOptionName ||

                "Option",
            },

            configs: [],
          };
        }

        acc[optionId].configs.push(
          activity
        );

        return acc;

      },
      {}
    )
  );


  return (
    <Container>
      <Card className="p-4 shadow-sm border-0 mt-2">
        <Row>
          {activitiesByOption.map(({ option, configs }) => (
            <Col md={6} key={option._id}>
              <Card className="p-3 mb-3 shadow-sm">
                <h5 className="text-center mb-3">{option.name}</h5>
                {configs.map((config) => {
                  const configIndex = activities.findIndex(
                    (a) =>
                      a.packageOption === config.packageOption &&
                      a.dayPlan === config.dayPlan,
                  );

              
                  return (
                    <Card key={configIndex} className="mb-3 p-3 border">
                      <h6>Day {configs.indexOf(config) + 1}</h6>

                      {config.activities.map((actRow, actIndex) => (
                        <Row key={actIndex} className="g-3 mb-2">
                          <Col md={4}>
                            <Form.Label>Activity</Form.Label>
                           <Select
  placeholder="Select Activity"
  value={
    masterActivities
      .map((act) => ({
        value: act._id,
        label: act.name,
      }))
     .find( (o) => String(o.value) === String( actRow.activity?._id || actRow.activity ) ) || null
  }
  onChange={(selected) =>
    handleChange(
      configIndex,
      actIndex,
      "activity",
      selected?.value || "",
    )
  }
  options={masterActivities.map((act) => ({
    value: act._id,
    label: act.name,
  }))}
/>
                          </Col>

                          {/* Vendor */}
                          <Col md={4}>
                            <Form.Label>Vendor</Form.Label>
                           <Select
  placeholder="Select Vendor"
  isDisabled={!actRow.activity}
  value={
    (
      vendorsMap[`${configIndex}_${actIndex}`] || []
    )
      .map((ven) => ({
        value: ven._id,
        label: ven.name,
      }))
    .find( (o) => String(o.value) === String( actRow.vendor?._id || actRow.vendor ) ) || null
  }
  onChange={(selected) =>
    handleChange(
      configIndex,
      actIndex,
      "vendor",
      selected?.value || "",
    )
  }
  options={(
    vendorsMap[`${configIndex}_${actIndex}`] || []
  ).map((ven) => ({
    value: ven._id,
    label: ven.name,
  }))}
/>
                          </Col>

                          {/* Timing */}
                          <Col md={3}>
                            <Form.Label>Timing</Form.Label>

                            <Form.Select
                              value={actRow.timing || ""}
                              onChange={(e) =>
                                handleChange(
                                  configIndex,
                                  actIndex,
                                  "timing",
                                  e.target.value,
                                )
                              }
                            >
                              <option value="">Select Timing</option>

                              {(
                                timingsMap[`${configIndex}_${actIndex}`] || []
                              ).map((time, i) => (
                                <option key={i} value={time}>
                                  {time}
                                </option>
                              ))}
                            </Form.Select>
                          </Col>
                          

                          {/* Remove Button */}
                          <Col md={1} className="d-flex align-items-end">
                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() =>
                                removeActivityRow(configIndex, actIndex)
                              }
                            >
                              ✕
                            </button>
                          </Col>
                        </Row>
                      ))}
                   <div className="d-flex gap-2 mt-2">
  <button
    type="button"
    className="cancel-btn btn-sm"
    onClick={() => addActivityRow(configIndex)}
  >
    + Add Activity
  </button>

  <button
    type="button"
    className="cancel-btn btn-sm"
    onClick={() => copyToAllOptions(config)}
  >
    Copy To All
  </button>
</div>
                    </Card>
                  );
                })}
              </Card>
            </Col>
          ))}
        </Row>
        <div className="d-flex justify-content-between mt-4 mb-5">
          <button className="cancel-btn" onClick={prevStep}>
            Previous
          </button>

          <button className="submit-btn" onClick={handleSubmit}>
            Next
          </button>
        </div>
      </Card>
    </Container>
  );
}
